import { getTheme, setTheme } from './theme.js';
import { prefetchTiles, estimateTileCount, lastPrefetchInfo } from '../data/tilePrefetch.js';

/**
 * Settings panel (gear button): light/dark mode, aircraft representation,
 * colour scale, home base, offline map download — plus global keyboard
 * shortcuts. Type/trail/dot filters, hide-ground and radius live in the filter
 * popout (ui/filterPanel.js); reset view + follow flight are floating map
 * buttons (ui/mapActions.js).
 */
export function setupControls(viewer, flightManager, flightStore, config, flightService) {
  const controlsPanel = document.getElementById('controlsPanel');
  const controlsToggle = document.getElementById('controlsToggle');
  const filterPanel = document.getElementById('filterPanel');
  const filterToggle = document.getElementById('filterToggle');

  controlsToggle.addEventListener('click', (e) => {
    e.stopPropagation();
    filterPanel.classList.remove('open'); // nie beide Popouts gleichzeitig
    filterToggle.classList.remove('active');
    controlsPanel.classList.toggle('open');
  });
  // Klick außerhalb schließt das Panel
  document.addEventListener('pointerdown', (e) => {
    if (controlsPanel.classList.contains('open') &&
        !controlsPanel.contains(e.target) && !controlsToggle.contains(e.target)) {
      controlsPanel.classList.remove('open');
    }
  });

  // Bodenverkehr ausblenden: Checkbox lebt jetzt im Filter-Panel (Wiring dort);
  // hier nur die Referenz für den Tastatur-Shortcut „g".
  const hideGroundCheckbox = document.getElementById('hideGround');

  // --- Hell/Dunkel-Modus ----------------------------------------------------
  const themeLight = document.getElementById('themeLight');
  const themeDark = document.getElementById('themeDark');

  function reflectTheme(theme) {
    themeLight.classList.toggle('active', theme === 'light');
    themeDark.classList.toggle('active', theme === 'dark');
  }
  themeLight.addEventListener('click', () => { setTheme('light'); reflectTheme('light'); });
  themeDark.addEventListener('click', () => { setTheme('dark'); reflectTheme('dark'); });
  reflectTheme(getTheme());

  // --- Flugzeug-Darstellung: 2D-Icons ↔ 3D-Modelle ---------------------------
  const viewMode2d = document.getElementById('viewMode2d');
  const viewMode3d = document.getElementById('viewMode3d');

  function applyViewMode(mode) {
    flightManager.setIconMode(mode);
    localStorage.setItem('frm-view-mode', mode);
    viewMode2d.classList.toggle('active', mode === '2d');
    viewMode3d.classList.toggle('active', mode === '3d');
  }
  viewMode2d.addEventListener('click', () => applyViewMode('2d'));
  viewMode3d.addEventListener('click', () => applyViewMode('3d'));
  // Anfangszustand aus dem FlightManager spiegeln (kommt aus localStorage)
  viewMode2d.classList.toggle('active', flightManager.iconMode === '2d');
  viewMode3d.classList.toggle('active', flightManager.iconMode === '3d');

  // --- Offline-Karte --------------------------------------------------------
  const offlineBtn = document.getElementById('offlineDownload');
  const offlineProgress = document.getElementById('offlineProgress');
  const offlineBarFill = document.getElementById('offlineBarFill');
  const offlineStatus = document.getElementById('offlineStatus');

  const info = lastPrefetchInfo();
  if (info) {
    offlineBtn.textContent = 'Offline-Karte aktualisieren';
  }

  let downloading = false;
  offlineBtn.addEventListener('click', async () => {
    if (downloading) return;
    downloading = true;
    offlineBtn.disabled = true;
    offlineProgress.classList.remove('hidden');

    const total = estimateTileCount(config.region.center, config.offline);
    offlineStatus.textContent = `0 / ${total} Kacheln…`;

    try {
      const result = await prefetchTiles({
        center: config.region.center,
        zoomRadii: config.offline.zoomRadii,
        theme: getTheme(),
        concurrency: 6,
        onProgress: (done, totalTiles) => {
          offlineBarFill.style.width = `${Math.round((done / totalTiles) * 100)}%`;
          offlineStatus.textContent = `${done} / ${totalTiles} Kacheln…`;
        }
      });
      offlineBarFill.style.width = '100%';
      offlineStatus.textContent =
        `✓ ${result.cached} Kacheln offline verfügbar (${result.failed} Fehler)`;
      offlineBtn.textContent = 'Offline-Karte aktualisieren';
    } catch (error) {
      offlineStatus.textContent = `Fehler: ${error.message}`;
    } finally {
      offlineBtn.disabled = false;
      downloading = false;
    }
  });

  // --- Tastatur-Shortcuts ---------------------------------------------------
  document.addEventListener('keydown', (e) => {
    switch (e.key) {
      case 'Escape':
        // Deselect
        viewer.selectedEntity = undefined;
        break;
      case 'r':
      case 'R':
        document.getElementById('resetViewBtn').click();
        break;
      case 'g':
      case 'G':
        // Toggle ground traffic
        hideGroundCheckbox.checked = !hideGroundCheckbox.checked;
        hideGroundCheckbox.dispatchEvent(new Event('change'));
        break;
    }
  });
}
